import type React from "react";
import { createContext, useCallback, useContext, useState } from "react";

import { V2ToastQueue, V2ToastRegion, type V2ToastContent } from "@stacklet/ui";

export type AlertStatus = V2ToastContent;

interface Context {
  alertDispatch: React.Dispatch<AlertStatus>;
}

const AlertContext = createContext<Context>({
  alertDispatch: () => {
    // do nothing
  },
});

export function AlertProvider({ children }: React.PropsWithChildren) {
  const [queue] = useState(
    () => new V2ToastQueue<V2ToastContent>({ maxVisibleToasts: 3 }),
  );

  const alertDispatch = useCallback(
    (action: AlertStatus) => {
      queue.add(action, {
        timeout: action.duration ?? 5000,
      });
    },
    [queue],
  );

  return (
    <AlertContext.Provider value={{ alertDispatch }}>
      <V2ToastRegion queue={queue} />
      {children}
    </AlertContext.Provider>
  );
}

export function useAlertContext(): Context {
  return useContext(AlertContext);
}
